import { z } from 'zod';
import isMongoId from '../../helpers/is-mongo-id';
import {
  InvestmentCompletionStatus,
  InvestmentArchiveStatus,
} from 'further-types/investment';

export const FreezeInvestmentInput = z.object({
  investmentId: z.string().refine(isMongoId(), {
    message: 'Invalid investment ID',
  }),
  freezeStartDate: z
    .string()
    .datetime()
    .nullable()
    .refine(
      (date) => {
        if (date && new Date(date) > new Date()) {
          return false;
        }
        return true;
      },
      {
        message: 'Freeze start date cannot be in the future.',
      },
    ),
});

export const MoveFundsInput = z.object({
  investmentId: z.string().refine(isMongoId(), {
    message: 'Invalid investment ID',
  }),
});

export const ReassignInvestorInput = z.object({
  investmentId: z.string().refine(isMongoId(), {
    message: 'Invalid investment ID',
  }),
  newInvestorId: z.string().refine(isMongoId(), {
    message: 'Invalid investor ID',
  }),
});

export const MutateIncompleteInvestmentInput = z.object({
  id: z.string().refine(isMongoId(), {
    message: 'Invalid cart ID',
  }),
});

export const ChangeIncompleteInvestmentTrancheInput = z.object({
  id: z.string().refine(isMongoId(), {
    message: 'Invalid cart ID',
  }),
  fundId: z.string().refine(isMongoId(), {
    message: 'Invalid fund ID',
  }),
});

export const ListPendingAdvisedForFundInput = z.object({
  fundId: z.string().refine(isMongoId(), {
    message: 'Invalid fund ID',
  }),
});

export const ReassignOrDeletePendingAdvisedInput = z.object({
  sourceFundId: z.string().refine(isMongoId(), {
    message: 'Invalid source fund ID',
  }),
  targetFundId: z
    .string()
    .refine(isMongoId(), {
      message: 'Invalid target fund ID',
    })
    .nullable()
    .optional(),
});

export const GetIncompleteInvestmentsInput = z.object({
  page: z.string().optional(),
  perPage: z.string().optional(),
  firmId: z
    .string()
    .optional()
    .transform((val) => (val === '' ? undefined : val))
    .refine((val) => !val || isMongoId()(val), {
      message: 'Invalid firm ID',
    }),
  fundId: z
    .string()
    .optional()
    .transform((val) => (val === '' ? undefined : val))
    .refine((val) => !val || isMongoId()(val), {
      message: 'Invalid fund ID',
    }),
  order: z.enum(['asc', 'desc']).optional(),
  search: z.string().optional(),
  orderBy: z.string().optional(),
  status: z.nativeEnum(InvestmentCompletionStatus).optional(),
  archiveStatus: z.nativeEnum(InvestmentArchiveStatus).optional(),
  isExport: z.boolean().optional(),
  showAdvisedOnly: z.boolean().optional(),
});
